module.exports = __webpack_public_path__ + "static/12-65fe2847a51065e75bac14f427221568.png";